import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon } from '@atlaskit/icon/base';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RunsOnAtlassianIcon = props => {
  const RunsOnAtlassianGlyph = customGlyphProps => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.customSize || '16',
    height: props.customSize || '16',
    viewBox: "0 0 16 16",
    fill: "none"
  }, customGlyphProps), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.00345 10.0153L6.67324 12.134C7.19836 12.3722 7.80076 12.3722 8.32588 12.134L12.9957 10.0153L13.4924 10.2407C14.2748 10.5957 14.2748 11.707 13.4924 12.062L7.91272 14.5934C7.65016 14.7126 7.34896 14.7126 7.0864 14.5934L1.50676 12.062C0.72431 11.707 0.724308 10.5957 1.50676 10.2407L2.00345 10.0153Z",
      fill: "var(--ds-icon-brand, #0C66E4)"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.00399 6.64497L6.67324 8.76338C7.19836 9.00163 7.80076 9.00163 8.32588 8.76338L12.9951 6.64497L13.4924 6.87056C14.2748 7.22555 14.2748 8.33688 13.4924 8.69187L7.91272 11.2233C7.65016 11.3425 7.34896 11.3425 7.0864 11.2233L1.50676 8.69187C0.72431 8.33688 0.724308 7.22555 1.50676 6.87056L2.00399 6.64497Z",
      fill: "var(--ds-icon-brand, #0C66E4)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.0864 0.968493C7.34896 0.84937 7.65016 0.84937 7.91272 0.968493L13.4924 3.49995C14.2748 3.85494 14.2748 4.96627 13.4924 5.32126L7.91272 7.85272C7.65016 7.97184 7.34896 7.97184 7.0864 7.85272L1.50676 5.32127C0.72431 4.96627 0.724308 3.85494 1.50676 3.49995L7.0864 0.968493Z",
      fill: "var(--ds-icon-brand, #0C66E4)"
    })]
  }));
  return /*#__PURE__*/_jsx(Icon, _objectSpread({
    glyph: RunsOnAtlassianGlyph
  }, props));
};